export class ListWithinList{
    hasSubList:boolean;
    listWithinListList = new Array<ListWithinList>();
    text: string;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/list-within-list.ts